export default {
  section_title: 'Gestión de impuestos',
  inherited_from_partner: 'Heredado',
  inherited_from_region: 'Predeterminado regional',
  reset: 'Restablecer a heredado',
  form: {
    tax_name: {
      label: 'Nombre del impuesto',
      tooltip: 'Cómo se denomina el impuesto en recibos y facturas, por ejemplo IVA.',
    },
    tax_behaviour: {
      label: 'Gestión de impuestos',
      tooltip: 'Si los precios de tu menú ya incluyen impuestos, o si se añaden al pagar.',
      options: {
        inclusive: 'Incluido en los precios del menú',
        exclusive: 'Añadido al pagar',
      },
    },
    delivery_fee_tax_percentage: {
      label: 'Tasa de impuesto del envío',
      tooltip: 'La tasa a la que se grava tu propio costo de envío, que puede diferir de la tasa aplicada a la comida.',
    },
  },
  impact: {
    title: '¿Cambiar el manejo de impuestos de tus restaurantes?',
    affected_one: '{{count}} restaurante sigue tu configuración predeterminada y cambiará.',
    affected_other: '{{count}} restaurantes siguen tu configuración predeterminada y cambiarán.',
    overriding_one: '{{count}} restaurante tiene su propia configuración y la mantendrá.',
    overriding_other: '{{count}} restaurantes tienen su propia configuración y la mantendrán.',
    confirm: 'Cambiarlos',
  },
  buttons: {
    save: 'Guardar',
    cancel: 'Cancelar',
  },
  toasts: {
    load_error: 'Error al cargar la configuración de impuestos',
    impact_error: 'Error al verificar qué restaurantes se verían afectados',
    impact_changed_one: 'El número de restaurantes afectados cambió a {{count}}. Revisa y guarda de nuevo.',
    impact_changed_other: 'El número de restaurantes afectados cambió a {{count}}. Revisa y guarda de nuevo.',
    failed_to_save_changes: 'Error al guardar los cambios',
    changes_got_saved: 'Los cambios se guardaron',
  },
};
